import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MersyMassReleaseRevokeDto } from '../../../../../../interfaces/mersymassreleaserevokedto';
import { Utils } from '../../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.less']
})
export class SummaryComponent {

    isLoading = false;

    constructor(
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
        public dialogRef: MatDialogRef<SummaryComponent>,
        @Inject(MAT_DIALOG_DATA) public summaryData: MersyMassReleaseRevokeDto,
        private readonly toastrService: ToastrService)
    {

    }

    public isOPL() {
        return this.summaryData.HierarchyType == "OPL";
    }
    public isReleaseAction() {
        return this.summaryData.ActionType == "Release";
    }

    onBackClick() {
        this.dialogRef.close();
    }

    postMassReleaseRevoke() {
        if (this.isLoading) return;
        this.isLoading = true;

        if (this.summaryData.HierarchyType === 'ACT' && (!this.summaryData.Periods || this.summaryData.Periods.length === 0)) {
            this.summaryData.Periods = Array.from({ length: 12 }, (_, i) => i + 1);
        }

        const url = this.baseUrl + Utils.getKpiManagementAPI() + '/massReleaseRevoke';

        Utils.httpPostTemplate(
            url,
            this.http,
            this.baseUrl,
            this.summaryData,
            this,
            function (tthis: SummaryComponent, data: any) {
                tthis.isLoading = false;
                if (data?.success) {
                    tthis.toastrService.success(
                        `Mass ${tthis.summaryData.ActionType} completed successfully.`
                    );
                    tthis.dialogRef.close({ success: true });
                } else {
                    const errorMsg = data?.errors?.join(', ') || 'Unknown error';
                    tthis.toastrService.warning(
                        `Mass ${tthis.summaryData.ActionType} partially completed. Errors: ${errorMsg}`
                    );
                    tthis.dialogRef.close({ success: false });
                }
            },
            function (tthis: SummaryComponent, error: any) {
                tthis.isLoading = false;
                tthis.toastrService.error(
                    `Mass ${tthis.summaryData.ActionType} failed. Please try again.`
                );
            }
        )
    }
}
